var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSelectedWasteTypes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.752,
    height: 37.805,
    viewBox: "0 0 66.752 37.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mina_avfallstyper",
    "data-name": "Mina avfallstyper",
    transform: "translate(-12041.481 -2162.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(12042.434 2163.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M306.359,835.2v-3.232c0-9.395,7.034-17.01,15.709-17.01h3.68c8.676,0,15.709,2.643,15.709-8.391v-5",
    transform: "translate(-306.359 -799.299)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    transform: "translate(11.485)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_266",
    "data-name": "Ellipse 266",
    cx: 6.067,
    cy: 6.067,
    rx: 6.067,
    ry: 6.067,
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26746",
    "data-name": "Group 26746",
    transform: "translate(12077.531 2169.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24302",
    "data-name": "Path 24302",
    d: "M353.2,1197.292a13.039,13.039,0,0,1,6.666,18.8",
    transform: "translate(-335.595 -1193.012)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24303",
    "data-name": "Path 24303",
    d: "M341.557,1212.089a13.042,13.042,0,0,1,12.824-15.354c.354,0,.7.015,1.049.042",
    transform: "translate(-341.35 -1193.283)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24304",
    "data-name": "Path 24304",
    d: "M362.638,1213.207a13.037,13.037,0,0,1-20.3-3.647",
    transform: "translate(-340.869 -1187.056)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24305",
    "data-name": "Path 24305",
    d: "M342.052,1215.293l-.064-6.042,5.929.679",
    transform: "translate(-341.04 -1187.205)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24306",
    "data-name": "Path 24306",
    d: "M347.624,1194.411l4.979,3.424-3.966,4.459",
    transform: "translate(-338.304 -1194.411)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24307",
    "data-name": "Path 24307",
    d: "M363.619,1208.84l-5.193,3.089-2.39-5.468",
    transform: "translate(-334.218 -1188.56)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectedWasteTypes);
export default __webpack_public_path__ + "static/media/Icon_selectedWasteTypes.e0020ad10b3985e70fbdb2e1aaaceeb4.svg";
export { ForwardRef as ReactComponent };